import { RouteConfig, Route } from 'vue-router';
import Layout from '@/layout/index.vue';
import { AppRoleType } from '@/utils/permission';

const groupRoutes: RouteConfig = {
  path: '/group',
  component: Layout,
  redirect: '/group/list',
  meta: {
    title: 'Group',
    icon: 'mdi-account-multiple-outline',
    alwaysShow: true,
    roles: [AppRoleType.ADMIN, AppRoleType.GROUP_ADMIN],
  },
  children: [
    {
      path: 'list',
      component: () =>
        import(/* webpackChunkName: "group" */ '@/views/group/list/index.vue'),
      name: 'group-list',
      meta: {
        title: 'Group list',
        icon: 'mdi-account-group-outline',
        roles: [AppRoleType.ADMIN, AppRoleType.GROUP_ADMIN],
      },
    },
    {
      path: 'create',
      component: () =>
        import(
          /* webpackChunkName: "group" */ '@/views/group/create/index.vue'
        ),
      name: 'group-create',
      meta: {
        title: 'Group create',
        icon: 'mdi-account-multiple-plus-outline',
        roles: [AppRoleType.ADMIN],
      },
    },
    {
      path: ':id',
      component: () =>
        import(
          /* webpackChunkName: "group" */ '@/views/group/detail/index.vue'
        ),
      name: 'group-detail',
      meta: {
        title: 'Group detail',
        icon: 'mdi-account-badge-horizontal-outline',
        hidden: true,
        roles: [AppRoleType.ADMIN, AppRoleType.GROUP_ADMIN],
      },
      props: route => ({
        id: route.params.id,
      }),
    },
  ],
};

export default groupRoutes;
